ACC.anonymouscheckout = {
  formFieldInput: 'ph-signup__error',
  formFieldError: 'ph-form_field_error',
  shippingForm: 'ph-anonymousshipping__address',
  emptyValue: 'ph-register__emptyvalue',
  accountForm: 'ph-anonymoussignup__wrapper',
  inputRadio: 'input[name=haveHealthCareAcct]:checked',
  accountFormChecker: '',
  shippingFormChecker: '',
  regApiCalldone: false,
  bindAll: function() {
    $('.ph-anonymousshipping__proceed').on('click', this.validateAccountDetails);
    $('#phonenumber').on('keyup', ACC.address.validatePhoneNumber);
    $('#accountnumber').on('keyup', ACC.address.validateCustomerAccountNumber);
    $('.ph-haveHealthCareAcct-radio').change(function() {
      ACC.anonymouscheckout.toggleInputForms();
    });

    $('.' + ACC.anonymouscheckout.shippingForm).find('.ph-forminput').on('blur', this.getDeliveryModeDynamically);
    $('.' + ACC.anonymouscheckout.accountForm + ' .ph-anonymousreg__main').find('.ph-forminput').on('blur', this.getAccountFormValidation);
    $('.' + ACC.anonymouscheckout.accountForm + ' .ph-anonymousreg__sub').find('.ph-forminput').on('blur', this.accountFormFieldValidation);
    $('.' + ACC.anonymouscheckout.accountForm + ' .ph-anonymousreg__sub').find('.ph-haveHealthCareAcct-radio').on('change', function() {
      if ($('.ph-anonymousreg__sub').find('.ph-forminput:visible').val() !== '') {
        $('.ph-anonymousreg__sub').find('.ph-forminput:visible').trigger('blur');
      }
    });

    $(document).on('blur', '#ph-postalCode2', function() {
      var postalCodeInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(postalCodeInputId);
      ACC.anonymouscheckout.getDeliveryModeDynamically();
    });
    $(document).on('blur', '#identifierNumber', function() {
      ACC.anonymouscheckout.npiFieldCheck('true', $(this));
      $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });
    $(document).on('keyup', '#identifierNumber', function() {
      $(this).val($(this).val().replace(/[^0-9]/g, ''));

      if (ACC.anonymouscheckout.isTenDigit($(this).val())) {
        ACC.anonymouscheckout.accountFormFieldValidation();
      } else {
        $(this).attr('apistatus', '');
        ACC.anonymouscheckout.accountFormFieldChecker = '';
        ACC.anonymouscheckout.npiPending();
        $('.ph-npifield_errormessage').addClass('hidden');
      }
    });
  },
  isTenDigit: function(npiFieldValue) {
    var returnVal = false,
        regexTendigit = new RegExp('^[0-9]{10}');

    if (regexTendigit.test(npiFieldValue)) {
      returnVal = true;
    }

    return returnVal;
  },
  npiPending: function() {
    $('.ph-anon_shipping_section').addClass('hidden');
  },
  showShippingSection: function() {
    if ($('.ph-anonymoussignup__npifield:visible').length > 0) {
      ACC.anonymouscheckout.npiPending();
    } else {
      $('.ph-anon_shipping_section').removeClass('hidden');
    }
  },
  accountUpdateAjaxAction: function(results) {
    results.forEach(function(result) {
      if (result.fieldId === 'identifierNumber') {
        ACC.anonymouscheckout.npiResponseMessage(result.fieldValidationStatus);
      }
    });
  },
  npiNotfoundMsg: function() {
    var $npiField = $('#identifierNumber'),
        npifieldErrormessage = $('.ph-npifield_errormessage > p').html();

    $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).addClass('ph-form_field_error');
    $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).html(npifieldErrormessage);
  },
  npiRemoveError: function() {
    var $npiField = $('#identifierNumber');

    $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).removeClass(ACC.anonymouscheckout.formFieldError);
    $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text('');
  },
  npiResponseMessage: function(fieldValidationStatus) {
    if (fieldValidationStatus === 'npiinactiveornotfound') {
      ACC.anonymouscheckout.npiPending();
      ACC.anonymouscheckout.npiNotfoundMsg();
    } else {
      $('.ph-anon_shipping_section').removeClass('hidden');
      ACC.anonymouscheckout.npiRemoveError();
    }

    $('#identifierNumber').attr('apistatus', fieldValidationStatus);
  },
  accountFieldUpdateAjax: function() {
    var $accountField = $('.' + ACC.anonymouscheckout.accountForm),
        dataObj = {
          emailAddress: $.trim($accountField.find('.ph-forminput[name=emailAddress]').val()),
          haveHealthCareAcct: $.trim($(ACC.anonymouscheckout.inputRadio).val()),
          custAccountNumber: $.trim($accountField.find('.ph-forminput[name=custAccountNumber]:visible').val()),
          identifierNumber: $.trim($accountField.find('.ph-forminput[name=identifierNumber]:visible').val()),
          commerceNumber: $.trim($accountField.find('.ph-forminput[name=commerceNumber]:visible').val()),
          vatRegistrationNumber: $.trim($accountField.find('.ph-forminput[name=vatRegistrationNumber]:visible').val()),
          bigNumber: $.trim($accountField.find('.ph-forminput[name=bigNumber]:visible').val())
        };

    var accountFormFieldChecker = JSON.stringify(Object.values(dataObj));

    if (ACC.anonymouscheckout.accountFormFieldChecker !== accountFormFieldChecker) {
      $('.ph-loader__default').removeClass('hidden');
      $.ajax({
        type: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        url: ACC.config.contextPath + '/anonymousCheckout/single/summary/anonymousRegistration.json',
        dataType: 'json',
        data: JSON.stringify(dataObj),
        success: function(responseData) {
          $('.ph-loader__default').addClass('hidden');

          if (responseData) {
            ACC.anonymouscheckout.accountUpdateAjaxAction(responseData);
          }
        },
        error: function() {
          $('.ph-loader__default').addClass('hidden');
          ACC.anonymouscheckout.npiResponseMessage('npiapidown');
        }
      });
      ACC.anonymouscheckout.accountFormFieldChecker = accountFormFieldChecker;
    }
  },
  npiFieldCheck: function(existingStatus, $npiField) {
    var validationSts = existingStatus,
        npiFieldValue = $.trim($npiField.val()),
        npiEmptyText = $npiField.closest('.ph-inputData').attr('data-emptyContent'),
        npiErrorText = $npiField.closest('.ph-inputData').attr('data-invalidnpi'),
        npiapistatus = $.trim($('#identifierNumber').attr('apistatus'));

    if (!npiFieldValue) {
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).addClass(ACC.anonymouscheckout.formFieldError);
      validationSts = false;
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text(npiEmptyText);
    } else if (ACC.anonymouscheckout.isTenDigit(npiFieldValue) === false) {
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).addClass(ACC.anonymouscheckout.formFieldError);
      validationSts = false;
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text(npiErrorText);
    } else if (ACC.anonymouscheckout.isTenDigit(npiFieldValue) === true && npiapistatus !== '') {
      if (npiapistatus === 'npiinactiveornotfound') {
        validationSts = false;
      }

      ACC.anonymouscheckout.npiResponseMessage(npiapistatus);
    } else {
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).removeClass(ACC.anonymouscheckout.formFieldError);
      $npiField.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text('');
    }

    return validationSts;
  },
  emailFieldCheck: function(accountValidationStatus) {
    var accountValidationSts = accountValidationStatus,
        $email = $('.checkoutEmailField:visible'),
        emailAddress = $email.val(),
        emailErrorText = $email.closest('.ph-inputData').attr('data-emptyContent'),
        philipsEmailRegx = new RegExp('@philips.com$', 'i'),
        phEmailErrorText = $email.closest('.ph-inputData').attr('data-philipsEmailMsg');

    if (ACC.validation.email(emailAddress)) {
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).addClass(ACC.anonymouscheckout.formFieldError);
      accountValidationSts = false;
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text(emailErrorText);
    } else if ($('.ph-loginRedirectToggle').length > 0 && philipsEmailRegx.test(emailAddress)) {
      accountValidationSts = false;
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).addClass(ACC.anonymouscheckout.formFieldError);
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text(phEmailErrorText);
    } else {
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).removeClass(ACC.anonymouscheckout.formFieldError);
      $email.closest('.' + ACC.anonymouscheckout.formFieldInput).find('.' + ACC.anonymouscheckout.emptyValue).text('');
      ACC.emailVerification.includeEmailinUrl(emailAddress);
    }

    return accountValidationSts;
  },
  npiResponseValidation: function(accountValidationStatus) {
    var statusValue = accountValidationStatus,
        apistatus = $('#identifierNumber').attr('apistatus');

    if (apistatus === 'npiinactiveornotfound') {
      statusValue = false;
      ACC.anonymouscheckout.npiResponseMessage(apistatus);
      $('html,body').animate({
        scrollTop: $('#haveHealthCareAcct').offset().top
      }, 'slow');
    }

    if (statusValue === true) {
      sessionStorage.setItem('isIdentifyNumberEntered', 'yes');
    }

    return statusValue;
  },
  validateAccountDetails: function() {
    var accountValidationStatus = true,
        isExistingUser = $(ACC.anonymouscheckout.inputRadio).val().toLowerCase();

    accountValidationStatus = ACC.anonymouscheckout.checkAllInputs(accountValidationStatus, 'ph-anonymoussignup__default');

    accountValidationStatus = ACC.anonymouscheckout.emailFieldCheck(accountValidationStatus);

    if (isExistingUser === 'yes') {
      accountValidationStatus = ACC.anonymouscheckout.checkAllInputs(accountValidationStatus, 'ph-anonymoussignup__existinguser');
    } else {
      accountValidationStatus = ACC.anonymouscheckout.checkAllInputs(accountValidationStatus, 'ph-anonymoussignup__newuser');
    }

    if ($('.ph-anonymoussignup__npifield:visible').length > 0) {
      accountValidationStatus = ACC.anonymouscheckout.npiFieldCheck(accountValidationStatus, $('#identifierNumber'));
    }

    if (accountValidationStatus) {
      accountValidationStatus = ACC.anonymouscheckout.checkAllInputs(accountValidationStatus, 'ph-checkout-shipping');
    }

    if ($('.ph-anonymoussignup__npifield:visible').length > 0 && accountValidationStatus === true) {
      accountValidationStatus = ACC.anonymouscheckout.npiResponseValidation(accountValidationStatus);
    }

    if (accountValidationStatus === true &&
       $('#shippingmodes').find('.form_field-container').length > 0 &&
      $('.ph-loader__default:visible').length === 0) {
      $('.ph-loader__default').removeClass('hidden');
      $('#anonymousShippingForm').submit();
    }
  },
  checkAllInputs: function(validationStatus, className) {
    var accountValidationStatus = validationStatus,
        errormsgValue = '',
        isMandatory = 'false',
        inputData = 'ph-inputData',
        formFieldInput = ACC.anonymouscheckout.formFieldInput,
        emptyValue = ACC.anonymouscheckout.emptyValue,
        formFieldError = ACC.anonymouscheckout.formFieldError,
        selectBoxAndclass = 'select.ph-forminput',
        dataOptional = 'data-optional';

    if (className === 'ph-anonymoussignup__newuser') {
      $('.' + className + ' input.ph-forminput, .' + className + ' ' + selectBoxAndclass).each(function() {
        errormsgValue = $(this).closest('.' + inputData).attr('data-emptyContent');
        isMandatory = $(this).closest('.' + inputData).attr('data-is-mandatory');

        if (($.trim($(this).val()) === '' || $(this).val() === null) && String($(this).attr(dataOptional)) !== 'true' && isMandatory === 'true') {
          $(this).closest('.' + formFieldInput).addClass(formFieldError);
          $(this).closest('.' + formFieldInput).find('.' + emptyValue).text(errormsgValue);
          accountValidationStatus = false;
        } else {
          $(this).closest('.' + formFieldInput).removeClass(formFieldError);
          $(this).closest('.' + formFieldInput).find('.' + emptyValue).text('');
        }
      });
    } else {
      $('.' + className + ' input.ph-forminput, .' + className + ' ' + selectBoxAndclass).each(function() {
        errormsgValue = $(this).closest('.' + inputData).attr('data-emptyContent');

        if (($.trim($(this).val()) === '' || $(this).val() === null) && String($(this).attr(dataOptional)) !== 'true') {
          $(this).closest('.' + formFieldInput).addClass(formFieldError);
          $(this).closest('.' + formFieldInput).find('.' + emptyValue).text(errormsgValue);
          accountValidationStatus = false;
        } else {
          $(this).closest('.' + formFieldInput).removeClass(formFieldError);
          $(this).closest('.' + formFieldInput).find('.' + emptyValue).text('');
        }
      });
    }

    return accountValidationStatus;
  },
  toggleInputForms: function() {
    var isExistingUser = $(ACC.anonymouscheckout.inputRadio).val().toLowerCase(),
        $newUser = $('.ph-anonymoussignup__newuser'),
        $existingUser = $('.ph-anonymoussignup__existinguser');

    if (isExistingUser === 'yes') {
      $newUser.addClass('hidden');
      $existingUser.removeClass('hidden');
      $('.ph-customergroup_selection').addClass('hidden');
      $('.ph-anonymoussignup__npifield').addClass('hidden');
    } else {
      $newUser.removeClass('hidden');
      $existingUser.addClass('hidden');
      $('#customerGroupSelection').removeClass('hidden');
      $('#customerGroupSelect').trigger('change');
      $('.ph-anonymoussignup__npifield').removeClass('hidden');
    }

    ACC.anonymouscheckout.showShippingSection();
  },
  resizeSelectBox: function() {
    var $allField = $('.ph-anonymoussignup__wrapper');

    $allField.find('select.ph-forminput').each(function() {
      $(this).selectBox();
    });
  },
  checkMandatoryField: function(isMandatory, currentField) {
    var isMandatoryReturn = isMandatory;

    if (String(currentField.attr('data-optional')) !== 'true') {
      isMandatoryReturn = 'true';
    }

    return isMandatoryReturn;
  },
  getAccountFormValidation: function() {
    var isValidAccount = true,
        isMandatory = 'false';

    $('.ph-anonymousreg__main').find('input.ph-forminput,select.ph-forminput').each(function() {
      isMandatory = ACC.anonymouscheckout.checkMandatoryField(isMandatory, $(this));

      var inputValue = $.trim($(this).val());

      if ($(this).is(':visible') === true && isMandatory === 'true' && !inputValue) {
        isValidAccount = false;
      }
    });

    if (isValidAccount === true) {
      ACC.anonymouscheckout.callAjaxAccount();
    }
  },
  accountFormFieldValidation: function() {
    var isValidAccount = true,
        isMandatory = 'false';

    $('.ph-anonymousreg__sub').find('input.ph-forminput,select.ph-forminput').each(function() {
      isMandatory = ACC.anonymouscheckout.checkMandatoryField(isMandatory, $(this));

      var inputValue = $.trim($(this).val());

      if ($(this).parents('.ph-inputData').attr('data-is-mandatory') === 'true') {
        isMandatory = 'true';
      } else if ($(this).parents('.ph-inputData').attr('data-is-mandatory') === 'false') {
        isMandatory = 'false';
      }

      if ($(this).is(':visible') === true && isMandatory === 'true' && !inputValue) {
        isValidAccount = false;
      }
    });

    if ($('.ph-anonymoussignup__npifield:visible').length > 0 && ACC.anonymouscheckout.isTenDigit($('#identifierNumber').val()) !== true) {
      isValidAccount = false;
    }

    if (ACC.anonymouscheckout.emailFieldCheck(true) === false) {
      isValidAccount = false;
    }

    if (isValidAccount === true && ACC.anonymouscheckout.regApiCalldone === true) {
      ACC.anonymouscheckout.accountFieldUpdateAjax();
    }
  },
  getDeliveryModeDynamically: function() {
    var isValid = true,
        formFieldInput = ACC.anonymouscheckout.formFieldInput,
        formFieldError = ACC.anonymouscheckout.formFieldError,
        emptyValue = ACC.anonymouscheckout.emptyValue,
        $addressField = $('.' + ACC.anonymouscheckout.shippingForm),
        postCodeInput = $addressField.find('#postCode');

    $addressField.find('input.ph-forminput,select.ph-forminput').each(function() {
      if (($.trim($(this).val()) === '' || $(this).val() === null) && String($(this).attr('data-optional')) !== 'true') {
        isValid = false;
      }
    });

    if (postCodeInput.val() !== '') {
      var inputData = 'ph-inputData',
          countryField = '',
          formatErrorText = postCodeInput.closest('.' + inputData).attr('data-formatError');

      if ($('#country').length > 0) {
        countryField = '#country';
      }

      if (ACC.validation.postalCode(postCodeInput.val(), countryField)) {
        postCodeInput.closest('.' + formFieldInput).addClass(formFieldError);
        postCodeInput.closest('.' + inputData).find('.' + emptyValue).text(formatErrorText);
        isValid = false;
      } else {
        postCodeInput.closest('.' + formFieldInput).removeClass(formFieldError);
        postCodeInput.closest('.' + inputData).find('.' + emptyValue).text('');
      }
    }

    if (isValid === true && $('#postCode').val() !== '') {
      ACC.anonymouscheckout.callAjax();
    }
  },
  callAjax: function() {
    $('.ph-dropship-error').hide();

    var $countryField = $('#country'),
        $addressField = $('.' + ACC.anonymouscheckout.shippingForm),
        dataObj = {
          line1: $addressField.find('.ph-forminput[name=line1]').val(),
          line2: $addressField.find('.ph-forminput[name=line2]').val(),
          townCity: $addressField.find('.ph-forminput[name=townCity]').val(),
          country: $addressField.find('.ph-forminput[name=country]').val(),
          regionIso: $addressField.find('.ph-forminput[name=regionIso]').val(),
          postcode: $addressField.find('.ph-forminput[name=postcode]').val()
        };

    if ($('.ph-isOneStore').html() === 'true' && $addressField.find('.ph-forminput[name=apartment]:visible').length > 0) {
      dataObj.houseno = $addressField.find('.ph-forminput[name=apartment]').val();
    }

    if ($countryField.length <= 0) {
      dataObj.country = null;
    }

    var shippingFormChecker = JSON.stringify(Object.values(dataObj));

    if (ACC.anonymouscheckout.shippingFormChecker !== shippingFormChecker) {
      $('.ph-loader__default').removeClass('hidden');
      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/anonymousCheckout/single/summary/createOneTimeShippingAddress.json',
        dataType: 'json',
        data: dataObj,
        success: function(otaResponse) {
          $('.ph-loader__default').addClass('hidden');
          ACC.address.reGenerateShippingModes(otaResponse.deliveryData);


          if (typeof otaResponse.addressData !== 'undefined') {
            ACC.address.generateAtpData(otaResponse.addressData);
          }

          ACC.address.reGenerateDeliveryModes(otaResponse.deliveryData);
          ACC.address.bindingDeliveryModesDom();

          $(document).find('.ph-delivery-mode').removeClass('hidden');
        }
      });
      ACC.anonymouscheckout.shippingFormChecker = shippingFormChecker;
    }
  },
  callAjaxAccount: function() {
    $('.ph-dropship-error').hide();

    var $accountField = $('.' + ACC.anonymouscheckout.accountForm),
        dataObj = {
          firstName: $accountField.find('.ph-forminput[name=firstName]').val(),
          lastName: $accountField.find('.ph-forminput[name=lastName]').val(),
          userTitle: $accountField.find('.ph-forminput[name=userTitle]').val(),
          phoneNumber: $accountField.find('.ph-forminput[name=phoneNumber]').val(),
          emailAddress: $accountField.find('.ph-forminput[name=emailAddress]').val(),
          orgType: $accountField.find('.ph-forminput[name=orgType]').val(),
          companyName: $accountField.find('.ph-forminput[name=companyName]').val(),
          haveHealthCareAcct: $(ACC.anonymouscheckout.inputRadio).val()
        };

    if ($('.ph-isOneStore').html() === 'true' && $accountField.find('.ph-forminput[name=apartment]:visible').length > 0) {
      dataObj.houseno = $accountField.find('.ph-forminput[name=apartment]').val();
    }

    var dataObjNew = {
      firstName: dataObj.firstName,
      lastName: dataObj.lastName,
      userTitle: dataObj.userTitle,
      phoneNumber: dataObj.phoneNumber,
      emailAddress: dataObj.emailAddress,
      orgType: dataObj.orgType,
      companyName: dataObj.companyName
    };

    var accountFormChecker = JSON.stringify(Object.values(dataObjNew));

    if (ACC.anonymouscheckout.accountFormChecker !== accountFormChecker) {
      $('.ph-loader__default').removeClass('hidden');
      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/anonymousCheckout/single/summary/createAnonymousRegistation.json',
        dataType: 'json',
        data: dataObj,
        success: function(data) {
          $('.ph-loader__default').addClass('hidden');
          ACC.anonymouscheckout.regApiCalldone = true;

          if (data.emailAlreadyExists === true) {
            $.colorbox({
              html: $('.ph-emailexists__parent').html(),
              width: '100%',
              maxHeight: '400px',
              maxWidth: '522px',
              close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
              overlayClose: false,
              onComplete: function() {
                ACC.common.refreshScreenReaderBuffer();
              },
              onClosed: function() {
                ACC.common.refreshScreenReaderBuffer();
              }
            });
          }

          if (data.invalidRegistration === true) {
            $('#globalMessagesTop').text($('.ph-invalidRegistration').text());
          }
        }
      });
      ACC.anonymouscheckout.accountFormChecker = accountFormChecker;
    }
  }
};

$(document).ready(function() {
  if ($(document).find('.ph-anonymous-checkout-flow').length > 0) {
    ACC.anonymouscheckout.bindAll();
    ACC.emailVerification.initCheckoutPage();
    ACC.anonymouscheckout.toggleInputForms();
    sessionStorage.removeItem('isIdentifyNumberEntered');

    if ($.trim($('.checkoutEmailField:visible').val()) !== '') {
      ACC.anonymouscheckout.regApiCalldone = true;
    }
  }

  window.addEventListener('orientationchange', ACC.anonymouscheckout.resizeSelectBox(), false);
});
